import {
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getRecommendedSkus = {
  name: "getRecommendedSkus" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        shopifyBin: z.string().nullable(),
        orderCount: z.number(),
      }),
    ),
  }),
};
